import type { HTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { classNames } from '@/ui/utils/main'

// Card container
const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, fwdRef) => (
    <div
      ref={fwdRef}
      className={classNames('rounded-lg border bg-card text-card-foreground shadow-sm', className)}
      {...props}
    />
  ),
)
Card.displayName = 'Card'

// Card header
const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, fwdRef) => (
    <div
      ref={fwdRef}
      className={classNames('flex flex-col space-y-1.5 p-6', className)}
      {...props}
    />
  ),
)
CardHeader.displayName = 'CardHeader'

// Card title
const CardTitle = forwardRef<HTMLHeadingElement, HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, fwdRef) => (
    <h3
      ref={fwdRef}
      className={classNames('text-2xl font-semibold leading-none tracking-tight', className)}
      {...props}
    />
  ),
)
CardTitle.displayName = 'CardTitle'

// Card description
const CardDescription = forwardRef<HTMLParagraphElement, HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, fwdRef) => (
    <p ref={fwdRef} className={classNames('text-sm text-muted-foreground', className)} {...props} />
  ),
)
CardDescription.displayName = 'CardDescription'

// Card content
const CardContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, fwdRef) => (
    <div ref={fwdRef} className={classNames('p-6 pt-0', className)} {...props} />
  ),
)
CardContent.displayName = 'CardContent'

// Card footer
const CardFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, fwdRef) => (
    <div ref={fwdRef} className={classNames('flex items-center p-6 pt-0', className)} {...props} />
  ),
)
CardFooter.displayName = 'CardFooter'

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter }
